import { Component } from '@angular/core';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent {
  public menuData: any[] = [
    {id: 1, name:'Gestion', icon: 'important_devices', route: '/main/gestion'},
    {id: 2, name:'Certificados', icon: 'wallpaper', route: '/main/certificados'},
    {id: 5, name:'Portafolio', icon: 'storage', route: '/main/portafolio'},
    {id: 3, name:'Carnet', icon: 'featured_play_list', route: '/main/carnet'},
    {id: 4, name:'Cotizador', icon: 'equalizer', route: '/main/cotizador'},
    {id: 5, name:'Link de pagos', icon: 'equalizer', route: '/main/link-pagos'},
  ];

  constructor(
    private mainCmp: MaincontainerComponent,
  ){}
  
  ngAfterViewInit(){
    setTimeout(() => {
      this.mainCmp.setTitle("Home");
    });
  }
}
